import { Component, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import { GRADE_BANDS } from "../../../models/constants"
import { GradeBand } from "../../../models/gradeBand.model"
import { CHNode } from "../../../models/node.model"
import { BrowsingService } from "../../../services/browsing.service"
import { LocalizationService } from "../../../services/localization.service"
import { EduComponent } from "../../../utils/eduComponent"
import ResourceUtils from "../../../utils/resource-utils"

@Component({
    selector: "app-main-navigation",
    templateUrl: "./main-navigation.component.html",
    styleUrls: ["./main-navigation.component.scss"],
})
export class MainNavigationComponent extends EduComponent implements OnInit {
    public gtmPrefix: string = "gtm-navigation-"
    public subjects: CHNode[]
    public predefinedSubjectsList: any = ResourceUtils.predefinedSubjectsList
    public isGradesPanelOpened = false
    public isSubjectsPanelOpened = false
    public stateName: string = null
    public GRADE_BANDS = GRADE_BANDS

    constructor(
        private browsingService: BrowsingService,
        private localizationService: LocalizationService,
        public router: Router
    ) {
        super()
    }

    public matchSubjectColour(id: number, subjectsList: any): string {
        return subjectsList.find((x) => x.subjectID === id).colour
    }

    public getAvailableSubjects(discipline) {
        return discipline.children.filter((node) => node.resultsCount > 0)
    }

    public ngOnInit() {
        this.addSub(
            this.browsingService.getSubjectsTree().subscribe(
                (data: CHNode[]) => {
                    this.subjects = data
                },
                (error) => console.error(`[CUSTOM Error]${error}`)
            )
        )

        this.subscriptions.push(
            this.localizationService.localizeData.subscribe((response) => {
                if (response && response.stateName) {
                    this.stateName = response.stateName
                } else {
                    this.stateName = null
                }
            })
        )
    }

    public toggleGradesPanel() {
        this.isGradesPanelOpened = !this.isGradesPanelOpened
        this.isSubjectsPanelOpened = false
    }

    public toggleSubjectsPanel() {
        this.isSubjectsPanelOpened = !this.isSubjectsPanelOpened
        this.isGradesPanelOpened = false
    }

    public navigateToGradeBand(gradeBand: GradeBand) {
        this.router.navigate([`/grades/${gradeBand.uri}/`])
        this.isGradesPanelOpened = false
    }
}
